import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { ReportQueryKeys } from "./keys";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { IReport } from "../../models/Reports/Report";

export default function useReport(reportId: string) {
  const { get } = useApiHelper();

  const report = useQuery({
    queryKey: ReportQueryKeys.single(reportId),
    queryFn: () =>
      get<IDefaultResponse<IReport>>(`/report/${reportId}`).then(
        (res) => res.data,
      ),
  });

  return {
    report,
  };
}
